import dhtmlXCellTop from './dhtmlXCellTop';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import dhtmlXLayoutCell from './dhtmlXLayoutCell';
import dhtmlXLayoutSepObject from './dhtmlXLayoutSepObject';

class dhtmlXLayoutObject extends dhtmlXCellTop {
    constructor(e, o, w) {
        super();
        var u = null;
        if (
            e != null &&
            typeof e == "object" &&
            typeof e.tagName == "undefined" &&
            e._isCell != true
        ) {
            u = {};
            if (e.autosize != null) {
                u.autosize = e.autosize;
            }
            if (e.cells != null) {
                u.cells = e.cells;
            }
            if (e.pattern != null) {
                o = e.pattern;
            }
            if (e.skin != null) {
                w = e.skin;
            }
            if (e.offsets != null) {
                u.offsets = e.offsets;
            }
            e = e.parent;
        }
        this.cdata = {};
        this.conf = {
            skin:
                w ||
                dhx4.skin ||
                (typeof dhtmlx != "undefined" ? dhtmlx.skin : null) ||
                dhx4.skinDetect("dhxlayout") ||
                "material",
            css: "dhxlayout",
            hh: 20,
            autosize: "b",
            nextCell: {a: "b", b: "a"},
            inited: false,
            b_size: {w: -1, h: -1}
        };
        if (this.conf.skin == "material") {
            this.conf.hh = dhx4.readFromCss(
                "dhxlayout_base_material dhxlayout_collapsed_height"
            );
        }
        if (typeof e == "object" && e._isCell == true) {
            var n = typeof u != "undefined" && u != null ? u : {};
            if (n.pattern == null && o != null) {
                n.pattern = o;
            }
            if (n.skin == null && w != null) {
                n.skin = w;
            }
            var l = e.attachLayout(n);
            return l;
        }
        dhtmlXCellTop.apply(this, [e, u == null ? null : u.offsets]);
        this.conf.sw = this._detectSW();
        var m = this;

        this.mainInst = e._layoutMainInst != null ? e._layoutMainInst : null;

        this._init = function (C) {
            var A = typeof C == "string" ? this.tplData[C] : C;
            this.conf.mode = A.mode;
            if (this.conf.mode == "c") {
                this.cdata.a = new dhtmlXLayoutCell("a", this);
            } else {
                this.cdata.a = new dhtmlXLayoutCell("a", this);
                this.cdata.b = new dhtmlXLayoutCell("b", this);
            }
            for (var y in this.cdata) {
                this.cont.appendChild(this.cdata[y].cell);
                this.cdata[y].conf.init = {w: 0.5, h: 0.5};
            }
            if (this.conf.mode != "c") {
                var x = this._getMainInst();
                if (x.conf.sep_idx == null) {
                    x.conf.sep_idx = 1;
                } else {
                    x.conf.sep_idx++;
                }
                this.sep = new dhtmlXLayoutSepObject(this.conf.mode, x.conf.sep_idx);
                this.cont.appendChild(this.sep.sep);
                this.sep._getLayout = function () {
                    return m._getLayout();
                };
                x = null;
            }
            if (A.cells != null) {
                for (let y in A.cells) {
                    if (A.cells[y].width != null) {
                        this.cdata[y].conf.init.w = A.cells[y].width;
                    }
                    if (A.cells[y].height != null) {
                        this.cdata[y].conf.init.h = A.cells[y].height;
                    }
                    if (A.cells[y].name != null) {
                        this.cdata[y].conf.name = A.cells[y].name;
                        this.cdata[y].setText(A.cells[y].name);
                    }
                    if (A.cells[y].fsize != null) {
                        this.cdata[y].conf.fsize = A.cells[y].fsize;
                    }
                }
            }
            this.setSizes();
            for (let y in this.cdata) {
                this.cdata[y].conf.init = {};
            }
            if (A.cells != null) {
                for (let y in A.cells) {
                    if (A.cells[y].layout != null) {
                        this.cdata[y].dataNested = true;
                        this.cdata[y]._layoutMainInst = this;
                        this.cdata[y].cell.className += " dhx_cell_nested_layout";
                        this.cdata[y].attachLayout({pattern: A.cells[y].layout});
                        this.cdata[y]._layoutMainInst = null;
                    }
                }
            }
        };
        this.setSizes = function (F, N, J, y) {
            try{
                var H =
                    this.conf.inited == true &&
                    this._getMainInst() == this &&
                    this.checkEvent("onResizeFinish") == true
                        ? {}
                        : false;
                var a = null, O = null, x = null, L = null, I = null, E = null, C = null, K = null;
                this._adjustCont();
                var M = this.cont.offsetWidth;
                var D = this.cont.offsetHeight;
                if (this.conf.mode == "c") {
                    a = 0;
                    O = 0;
                    x = M;
                    L = D;
                    this.cdata.a._setSize(a, O, x, L, F, J, y);
                    this.callEvent("_onSetSizes", []);
                    if (H && !(this.conf.b_size.w == M && this.conf.b_size.h == D)) {
                        this._callMainEvent("onResizeFinish", []);
                    }
                    this.conf.b_size = {w: M, h: D};
                    return;
                }
                if (typeof N == "undefined") {
                    this.conf.mode == "v" ? "w" : "h";
                    N = this.conf.autosize;
                    if (this.cdata.a.conf.collapsed) {
                        N = "b";
                    } else {
                        if (this.cdata.b.conf.collapsed) {
                            N = "a";
                        } else {
                            if (F == "a" || F == "b") {
                                N = this.conf.nextCell[F];
                            }
                        }
                    }
                }
                if (this.conf.mode == "v") {
                    if (N == "a") {
                        if (this.cdata.b.conf.init.w != null) {
                            K = Math.round(M * this.cdata.b.conf.init.w - this.conf.sw / 2);
                        } else {
                            K = this.cdata.b.conf.size.w;
                        }
                        I = M - K;
                        E = 0;
                        C = D;
                        a = 0;
                        O = E;
                        x = I - a - this.conf.sw;
                        L = C;
                    } else {
                        a = 0;
                        O = 0;
                        if (this.cdata.a.conf.init.w != null) {
                            x =
                                Math.round(M * this.cdata.a.conf.init.w - this.conf.sw / 2) - a;
                        } else {
                            x = this.cdata.a.conf.size.w;
                        }
                        L = D - O;
                        I = a + x + this.conf.sw;
                        E = O;
                        K = M - I;
                        C = L;
                    }
                    this.cdata.a._setSize(a, O, x, L, F, J, y);
                    this.cdata.b._setSize(I, E, K, C, F, J, y);
                    this.sep&&this.sep._setSize(a + x, O, this.conf.sw, L);
                } else {
                    if (N == "a") {
                        if (this.cdata.b.conf.init.h != null) {
                            C = Math.round(D * this.cdata.b.conf.init.h - this.conf.sw / 2);
                        } else {
                            C = this.cdata.b.conf.size.h;
                        }
                        I = 0;
                        E = D - C;
                        K = M - I;
                        a = I;
                        O = 0;
                        x = K;
                        L = E - O - this.conf.sw;
                    } else {
                        a = 0;
                        O = 0;
                        x = M - a;
                        if (this.cdata.a.conf.init.h != null) {
                            L = Math.round(D * this.cdata.a.conf.init.h - this.conf.sw / 2);
                        } else {
                            L = this.cdata.a.conf.size.h;
                        }
                        I = a;
                        E = O + L + this.conf.sw;
                        K = x;
                        C = D - E;
                    }
                    this.cdata.a._setSize(a, O, x, L, F, J, y);
                    this.cdata.b._setSize(I, E, K, C, F, J, y);
                    this.sep._setSize(a, O + L, x, this.conf.sw);
                }
                this.callEvent("_onSetSizes", []);
                if (H && !(this.conf.b_size.w == M && this.conf.b_size.h == D)) {
                    this._callMainEvent("onResizeFinish", []);
                }
                this.conf.b_size = {w: M, h: D};
            }catch (e) {
                console.log(e,"--setSize");
            }
        };

        this.unload = function () {
            this.conf.unloading = true;
            this.mainInst = null;
            this.parentLayout = null;
            if (this.items != null) {
                for (var y = 0; y < this.items.length; y++) {
                    this.items[y] = null;
                }
                this.items = null;
            }
            if (this.dhxWins != null) {
                this.dhxWins.unload();
                this.dhxWins = null;
            }
            if (this.sep != null) {
                this.sep._unload();
                this.sep = null;
            }
            for (var x in this.cdata) {
                this.cdata[x]._unload();
                this.cdata[x] = null;
            }
            this._unloadTop();
            dhx4._eventable(this, "clear");
            for (let x in this) {
                this[x] = null;
            }
            m = null;
        };
        this._getWindowMinDimension = function () {
            var aWid = m._getAvailWidth() + 7 + 7;
            var y = m._getAvailHeight() + 7 + 31;
            var x = {w: Math.max(aWid, 200), h: Math.max(y, 140)};
            aWid = null;
            return x;
        };
        dhx4._eventable(this);
        this._callMainEvent = function (x, a) {
            return this.callEvent(x, a);
        };
        this._init(o || "3E");
        var r = this._availAutoSize[o];
        if (r != null) {
            this.conf.pattern = o;
            this.setAutoSize(r.h[r.h.length - 1], r.v[r.v.length - 1]);
        }
// if (typeof window.dhtmlXWindows == "function" && this.mainInst == null) {
//   var g = { vp_overflow: this.conf.fs_mode == true ? false : "auto" };
//   this.dhxWins = new dhtmlXWindows(g);
//   this.dhxWins.setSkin(this.conf.skin);
// }
        this.conf.inited = true;
        if (this == this._getMainInst()) {
            var s = 0;
            this.items = [];
            this.forEachItem(function (a) {
                m.items.push(a);
                a.conf.index = s++;
            });
        }
        if (this == this._getMainInst() && u != null) {
            if (u.autosize != null) {
                this.setAutoSize.apply(this, u.autosize);
            }
            if (u.cells != null) {
                for (var c = 0; c < u.cells.length; c++) {
                    var h = u.cells[c];
                    var v = this.cells(h.id);
                    if (h.width) {
                        v.setWidth(h.width);
                    }
                    if (h.height) {
                        v.setHeight(h.height);
                    }
                    if (h.text) {
                        v.setText(h.text);
                    }
                    if (h.collapsed_text) {
                        v.setCollapsedText(h.collapsed_text);
                    }
                    if (h.collapse) {
                        v.collapse();
                    }
                    if (h.fix_size) {
                        v.fixSize(h.fix_size[0], h.fix_size[1]);
                    }
                    if (
                        typeof h.header != "undefined" &&
                        dhx4.s2b(h.header) == false
                    ) {
                        v.hideHeader();
                    }
                }
            }
        }
        u = null;
        return this;
    }
}
dhtmlXLayoutObject.prototype._getAvailWidth = function () {
    var A = [];
    for (var E = 0; E < this.conf.as_cells.h.length; E++) {
        var x = this.cells(this.conf.as_cells.h[E]);
        var C = x.layout;
        var y = C.conf.autosize;
        if (x.conf.collapsed) {
            x = C.cdata[C.conf.nextCell[x._idd]];
            y = C.conf.nextCell[y];
        }
        A.push(Math.max(0, x.getWidth() - x._getMinWidth(y)));
        C = x = null;
    }
    var D = A.length > 0 ? Math.min.apply(window, A) : 0;
    return this.cont.offsetWidth - D;
};
dhtmlXLayoutObject.prototype._getAvailHeight = function () {
    var C = [];
    for (var E = 0; E < this.conf.as_cells.v.length; E++) {
        var x = this.cells(this.conf.as_cells.v[E]);
        var A = x.layout;
        var y = A.conf.autosize;
        if (x.conf.collapsed) {
            x = A.cdata[A.conf.nextCell[x._idd]];
            y = A.conf.nextCell[y];
        }
        C.push(Math.max(0, x.getHeight() - x._getHdrHeight() - x._getMinHeight(y)));
        A = x = null;
    }
    var D = Math.min.apply(window, C);
    return this.cont.offsetHeight - D;
};
dhtmlXLayoutObject.prototype.setSkin = function (a) {
    this._setBaseSkin(a);
    this.conf.skin = a;
};
dhtmlXLayoutObject.prototype._getMainInst = function () {
    if (this.mainInst != null) {
        return this.mainInst._getMainInst();
    }
    return this;
};
dhtmlXLayoutObject.prototype._getLayout = function () {
    return this;
};
dhtmlXLayoutObject.prototype.cells = function (g) {
    for (var c in this.cdata) {
        if (this.cdata[c]&&this.cdata[c].conf&&this.cdata[c].conf.name == g) {
            return this.cdata[c];
        }
        if (this.cdata[c].dataType == "layout" &&
            this.cdata[c].dataNested == true &&
            this.cdata[c].dataObj != null) {
            var e = this.cdata[c].dataObj.cells(g);
            if (e != null) {
                return e;
            }
        }
    }
    return null;
};
dhtmlXLayoutObject.prototype.forEachItem = function (g, e) {
    if (typeof g != "function") {
        return;
    }
    if (typeof e == "undefined") {
        e = this;
    }
    for (var c in this.cdata) {
        if (typeof this.cdata[c].conf.name != "undefined") {
            g.apply(e, [this.cdata[c]]);
        }
        if (this.cdata[c].dataType == "layout" &&
            this.cdata[c].dataNested == true &&
            this.cdata[c].dataObj != null) {
            this.cdata[c].dataObj.forEachItem(g, e);
        }
    }
    e = null;
};
dhtmlXLayoutObject.prototype._forEachSep = function (g, e) {
    if (typeof g != "function") {
        return;
    }
    if (typeof e == "undefined") {
        e = this;
    }
    if (this.sep != null) {
        g.apply(e, [this.sep]);
    }
    for (var c in this.cdata) {
        if (this.cdata[c]&&this.cdata[c].dataType == "layout" &&
            this.cdata[c].dataNested == true &&
            this.cdata[c].dataObj != null) {
            this.cdata[c].dataObj._forEachSep(g, e);
        }
    }
    e = null;
};
dhtmlXLayoutObject.prototype._detectSW = function () {
    if (this._confGlob.sw == null) {
        this._confGlob.sw = {};
    }
    if (this._confGlob.sw[this.conf.skin] == null) {
        this._confGlob.sw[this.conf.skin] = dhx4.readFromCss("dhxlayout_sep_sw_" + this.conf.skin);
    }
    return this._confGlob.sw[this.conf.skin];
};
dhtmlXLayoutObject.prototype._confGlob = {};
dhtmlXLayoutObject.prototype.listPatterns = function () {
    var e = [];
    for (var c in this.tplData) {
        e.push(c);
    }
    return e;
};
dhtmlXLayoutObject.prototype.listAutoSizes = function () {
    var g = this.conf.as_cells != null ? this.conf.as_cells.h.join(";") : "";
    var e = this.conf.as_cells != null ? this.conf.as_cells.v.join(";") : "";
    var c = this._availAutoSize[this.conf.pattern].h;
    var a = this._availAutoSize[this.conf.pattern].v;
    return [g, e, c, a];
};
dhtmlXLayoutObject.prototype._getCellsNames = function (g) {
    var h = {};
    if (this.cdata[g].conf.name != null) {
        h[this.cdata[g].conf.name] = true;
    }
    if (this.cdata[g].dataType == "layout" &&
        this.cdata[g].dataObj != null &&
        this.cdata[g].dataObj.mainInst == this) {
        var c = this.cdata[g].dataObj._getCellsNames("a");
        var l = this.cdata[g].dataObj._getCellsNames("b");
        for (var e in c) {
            h[e] = c[e];
        }
        for (var e_1 in l) {
            h[e_1] = l[e_1];
        }
    }
    return h;
};
dhtmlXLayoutObject.prototype.setAutoSize = function (c, o, r) {
    if (r !== true) {
        var v = this.listAutoSizes();
        if (v[0] == c && v[1] == o) {
            return;
        }
        var n = false;
        var l = false;
        for (var e_2 = 0; e_2 < v[2].length; e_2++) {
            n = n || v[2][e_2] == c;
        }
        for (var e_3 = 0; e_3 < v[3].length; e_3++) {
            l = l || v[3][e_3] == o;
        }
        if (!n || !l) {
            return;
        }
    }
    this.conf.as_cells = { h: c.split(";"), v: o.split(";") };
    var g = this.conf.mode == "v" ? "h" : "v";
    for (var u in this.cdata) {
        var h = this._getCellsNames(u);
        var w = false;
        for (var e = 0; e < this.conf.as_cells[g].length; e++) {
            w = w || h[this.conf.as_cells[g][e]];
        }
        if (w) {
            this.conf.autosize = u;
        }
        if (this.cdata[u].dataType == "layout" && this.cdata[u].dataObj != null) {
            this.cdata[u].dataObj.setAutoSize(c, o, true);
        }
    }
};
dhtmlXLayoutObject.prototype.tplData = {
    "1C": { mode: "c", cells: { a: { name: "a" } } },
    "2E": {
        mode: "h",
        cells: {
            a: { name: "a", fsize: { v: 1 } },
            b: { name: "b", fsize: { v: 1 } }
        }
    },
    "2U": {
        mode: "v",
        cells: {
            a: { name: "a", fsize: { h: 1 } },
            b: { name: "b", fsize: { h: 1 } }
        }
    },
    "3E": {
        mode: "h",
        cells: {
            a: { name: "a", height: 1 / 3, fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "b", fsize: { v: [1, 2] } },
                        b: { name: "c", fsize: { v: 2 } }
                    }
                }
            }
        }
    },
    "3W": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 3, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", fsize: { h: [1, 2] } },
                        b: { name: "c", fsize: { h: 2 } }
                    }
                }
            }
        }
    },
    "3J": {
        mode: "v",
        cells: {
            a: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", fsize: { h: 1, v: 2 } },
                        b: { name: "c", fsize: { h: 1, v: 2 } }
                    }
                }
            },
            b: { name: "b", fsize: { h: 1 } }
        }
    },
    "3L": {
        mode: "v",
        cells: {
            a: { name: "a", fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "b", fsize: { h: 1, v: 2 } },
                        b: { name: "c", fsize: { h: 1, v: 2 } }
                    }
                }
            }
        }
    },
    "3T": {
        mode: "h",
        cells: {
            a: { name: "a", fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", fsize: { h: 2, v: 1 } },
                        b: { name: "c", fsize: { h: 2, v: 1 } }
                    }
                }
            }
        }
    },
    "3U": {
        mode: "h",
        cells: {
            a: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "a", fsize: { h: 2, v: 1 } },
                        b: { name: "b", fsize: { h: 2, v: 1 } }
                    }
                }
            },
            b: { name: "c", fsize: { v: 1 } }
        }
    },
    "4H": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 3, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", fsize: { h: [1, 2], v: 3 } },
                                    b: { name: "c", fsize: { h: [1, 2], v: 3 } }
                                }
                            }
                        },
                        b: { name: "d", fsize: { h: 2 } }
                    }
                }
            }
        }
    },
    "4I": {
        mode: "h",
        cells: {
            a: { name: "a", height: 1 / 3, fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "b", fsize: { h: 3, v: [1, 2] } },
                                    b: { name: "c", fsize: { h: 3, v: [1, 2] } }
                                }
                            }
                        },
                        b: { name: "d", fsize: { v: 2 } }
                    }
                }
            }
        }
    },
    "4T": {
        mode: "h",
        cells: {
            a: { name: "a", fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", width: 1 / 3, fsize: { h: 2, v: 1 } },
                        b: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "c", fsize: { h: [2, 3], v: 1 } },
                                    b: { name: "d", fsize: { h: 3, v: 1 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "4U": {
        mode: "h",
        cells: {
            a: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "a", width: 1 / 3, fsize: { h: 2, v: 1 } },
                        b: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "b", fsize: { h: [2, 3], v: 1 } },
                                    b: { name: "c", fsize: { h: 3, v: 1 } }
                                }
                            }
                        }
                    }
                }
            },
            b: { name: "d", fsize: { v: 1 } }
        }
    },
    "4E": {
        mode: "h",
        cells: {
            a: { name: "a", height: 1 / 4, fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "b", height: 1 / 3, fsize: { v: [1, 2] } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "c", fsize: { v: [2, 3] } },
                                    b: { name: "d", fsize: { v: 3 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "4W": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 4, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", width: 1 / 3, fsize: { h: [1, 2] } },
                        b: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "c", fsize: { h: [2, 3] } },
                                    b: { name: "d", fsize: { h: 3 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "4A": {
        mode: "v",
        cells: {
            a: {
                width: 1 / 3,
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", fsize: { h: 1, v: 2 } },
                        b: { name: "b", fsize: { h: 1, v: 2 } }
                    }
                }
            },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "c", fsize: { h: [1, 3] } },
                        b: { name: "d", fsize: { h: 3 } }
                    }
                }
            }
        }
    },
    "4L": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 3, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", fsize: { h: [1, 2] } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "c", fsize: { h: 2, v: 3 } },
                                    b: { name: "d", fsize: { h: 2, v: 3 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "4J": {
        mode: "h",
        cells: {
            a: { name: "a", height: 1 / 3, fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "b", fsize: { v: [1, 2] } },
                        b: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "c", fsize: { h: 3, v: 2 } },
                                    b: { name: "d", fsize: { h: 3, v: 2 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "4F": {
        mode: "h",
        cells: {
            a: {
                height: 1 / 3,
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "a", fsize: { h: 2, v: 1 } },
                        b: { name: "b", fsize: { h: 2, v: 1 } }
                    }
                }
            },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "c", fsize: { v: [1, 3] } },
                        b: { name: "d", fsize: { v: 3 } }
                    }
                }
            }
        }
    },
    "4G": {
        mode: "v",
        cells: {
            a: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", height: 1 / 3, fsize: { h: 1, v: 2 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", fsize: { h: 1, v: [2, 3] } },
                                    b: { name: "c", fsize: { h: 1, v: 3 } }
                                }
                            }
                        }
                    }
                }
            },
            b: { name: "d", fsize: { h: 1 } }
        }
    },
    "4C": {
        mode: "v",
        cells: {
            a: { name: "a", fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "b", height: 1 / 3, fsize: { h: 1, v: 2 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "c", fsize: { h: 1, v: [2, 3] } },
                                    b: { name: "d", fsize: { h: 1, v: 3 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "5H": {
        mode: "v",
        cells: {
            a: { width: 1 / 3, name: "a", fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", height: 1 / 3, fsize: { h: [1, 2], v: 3 } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: { name: "c", fsize: { h: [1, 2], v: [3, 4] } },
                                                b: { name: "d", fsize: { h: [1, 2], v: 4 } }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        b: { name: "e", fsize: { h: 2 } }
                    }
                }
            }
        }
    },
    "5I": {
        mode: "h",
        cells: {
            a: { height: 1 / 3, name: "a", fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "b", width: 1 / 3, fsize: { h: 3, v: [1, 2] } },
                                    b: {
                                        layout: {
                                            mode: "v",
                                            cells: {
                                                a: { name: "c", fsize: { h: [3, 4], v: [1, 2] } },
                                                b: { name: "d", fsize: { h: 4, v: [1, 2] } }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        b: { name: "e", fsize: { v: 2 } }
                    }
                }
            }
        }
    },
    "5U": {
        mode: "h",
        cells: {
            a: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "a", width: 1 / 4, fsize: { h: 2, v: 1 } },
                        b: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "b", width: 1 / 3, fsize: { h: [2, 3], v: 1 } },
                                    b: {
                                        layout: {
                                            mode: "v",
                                            cells: {
                                                a: { name: "c", fsize: { h: [3, 4], v: 1 } },
                                                b: { name: "d", fsize: { h: 4, v: 1 } }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            b: { name: "e", fsize: { v: 1 } }
        }
    },
    "5E": {
        mode: "h",
        cells: {
            a: { name: "a", height: 1 / 5, fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "b", height: 1 / 4, fsize: { v: [1, 2] } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "c", height: 1 / 3, fsize: { v: [2, 3] } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: { name: "d", fsize: { v: [3, 4] } },
                                                b: { name: "e", fsize: { v: 4 } }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "5W": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 5, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", width: 1 / 4, fsize: { h: [1, 2] } },
                        b: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "c", width: 1 / 3, fsize: { h: [2, 3] } },
                                    b: {
                                        layout: {
                                            mode: "v",
                                            cells: {
                                                a: { name: "d", fsize: { h: [3, 4] } },
                                                b: { name: "e", fsize: { h: 4 } }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "5K": {
        mode: "v",
        cells: {
            a: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", height: 1 / 3, fsize: { h: 1, v: 2 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", fsize: { h: 1, v: [2, 3] } },
                                    b: { name: "c", fsize: { h: 1, v: 3 } }
                                }
                            }
                        }
                    }
                }
            },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "d", fsize: { h: 1, v: 4 } },
                        b: { name: "e", fsize: { h: 1, v: 4 } }
                    }
                }
            }
        }
    },
    "5S": {
        mode: "v",
        cells: {
            a: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", fsize: { h: 1, v: 2 } },
                        b: { name: "b", fsize: { h: 1, v: 2 } }
                    }
                }
            },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "c", height: 1 / 3, fsize: { h: 1, v: 3 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "d", fsize: { h: 1, v: [3, 2] } },
                                    b: { name: "e", fsize: { h: 1, v: 4 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "5G": {
        mode: "v",
        cells: {
            a: {
                width: 1 / 3,
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", height: 1 / 3, fsize: { h: 1, v: 2 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", fsize: { h: 1, v: [2, 3] } },
                                    b: { name: "c", fsize: { h: 1, v: 3 } }
                                }
                            }
                        }
                    }
                }
            },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "d", fsize: { h: [1, 4] } },
                        b: { name: "e", fsize: { h: 4 } }
                    }
                }
            }
        }
    },
    "5C": {
        mode: "v",
        cells: {
            a: {
                width: 2 / 3,
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "a", fsize: { h: 2 } },
                        b: { name: "b", fsize: { h: [2, 1] } }
                    }
                }
            },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "c", height: 1 / 3, fsize: { h: 1, v: 3 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "d", fsize: { h: 1, v: [3, 4] } },
                                    b: { name: "e", fsize: { h: 1, v: 4 } }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "6H": {
        mode: "v",
        cells: {
            a: { width: 1 / 3, name: "a", fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", height: 1 / 4, fsize: { h: [1, 2], v: 3 } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: {
                                                    name: "c",
                                                    height: 1 / 3,
                                                    fsize: { h: [1, 2], v: [3, 4] }
                                                },
                                                b: {
                                                    layout: {
                                                        mode: "h",
                                                        cells: {
                                                            a: { name: "d", fsize: { h: [1, 2], v: [4, 5] } },
                                                            b: { name: "e", fsize: { h: [1, 2], v: 5 } }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        b: { name: "f", fsize: { h: 2 } }
                    }
                }
            }
        }
    },
    "6I": {
        mode: "h",
        cells: {
            a: { height: 1 / 3, name: "a", fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "b", width: 1 / 4, fsize: { h: 3, v: [1, 2] } },
                                    b: {
                                        layout: {
                                            mode: "v",
                                            cells: {
                                                a: {
                                                    name: "c",
                                                    width: 1 / 3,
                                                    fsize: { h: [3, 4], v: [1, 2] }
                                                },
                                                b: {
                                                    layout: {
                                                        mode: "v",
                                                        cells: {
                                                            a: { name: "d", fsize: { h: [4, 5], v: [1, 2] } },
                                                            b: { name: "e", fsize: { h: 5, v: [1, 2] } }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        b: { name: "f", fsize: { v: 2 } }
                    }
                }
            }
        }
    },
    "6A": {
        mode: "v",
        cells: {
            a: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", height: 1 / 5, fsize: { h: 1, v: 2 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", height: 1 / 4, fsize: { h: 1, v: [2, 3] } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: {
                                                    name: "c",
                                                    height: 1 / 3,
                                                    fsize: { h: 1, v: [3, 4] }
                                                },
                                                b: {
                                                    layout: {
                                                        mode: "h",
                                                        cells: {
                                                            a: { name: "d", fsize: { h: 1, v: [4, 5] } },
                                                            b: { name: "e", fsize: { h: 1, v: 5 } }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            b: { name: "f", fsize: { h: 1 } }
        }
    },
    "6C": {
        mode: "v",
        cells: {
            a: { name: "a", fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "b", height: 1 / 5, fsize: { h: 1, v: 2 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "c", height: 1 / 4, fsize: { h: 1, v: [2, 3] } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: {
                                                    name: "d",
                                                    height: 1 / 3,
                                                    fsize: { h: 1, v: [3, 4] }
                                                },
                                                b: {
                                                    layout: {
                                                        mode: "h",
                                                        cells: {
                                                            a: { name: "e", fsize: { h: 1, v: [4, 5] } },
                                                            b: { name: "f", fsize: { h: 1, v: 5 } }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "6J": {
        mode: "v",
        cells: {
            a: {
                width: 1 / 3,
                layout: {
                    mode: "h",
                    cells: {
                        a: { name: "a", height: 1 / 4, fsize: { h: 1, v: 2 } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", height: 1 / 3, fsize: { h: 1, v: [2, 3] } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: { name: "c", fsize: { h: 1, v: [3, 4] } },
                                                b: { name: "d", fsize: { h: 1, v: 4 } }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "e", fsize: { h: [1, 5] } },
                        b: { name: "f", fsize: { h: 5 } }
                    }
                }
            }
        }
    },
    "6E": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 3, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", fsize: { h: [1, 2] } },
                        b: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "c", height: 1 / 4, fsize: { h: 2, v: 3 } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: {
                                                    name: "d",
                                                    height: 1 / 3,
                                                    fsize: { h: 2, v: [3, 4] }
                                                },
                                                b: {
                                                    layout: {
                                                        mode: "h",
                                                        cells: {
                                                            a: { name: "e", fsize: { h: 2, v: [4, 5] } },
                                                            b: { name: "f", fsize: { h: 2, v: 5 } }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "6W": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 6, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: { name: "b", width: 1 / 5, fsize: { h: [1, 2] } },
                        b: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "c", width: 1 / 4, fsize: { h: [2, 3] } },
                                    b: {
                                        layout: {
                                            mode: "v",
                                            cells: {
                                                a: { name: "d", width: 1 / 3, fsize: { h: [3, 4] } },
                                                b: {
                                                    layout: {
                                                        mode: "v",
                                                        cells: {
                                                            a: { name: "e", fsize: { h: [4, 5] } },
                                                            b: { name: "f", fsize: { h: 5 } }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "7H": {
        mode: "v",
        cells: {
            a: { name: "a", width: 1 / 3, fsize: { h: 1 } },
            b: {
                layout: {
                    mode: "v",
                    cells: {
                        a: {
                            layout: {
                                mode: "h",
                                cells: {
                                    a: { name: "b", height: 1 / 5, fsize: { h: [1, 2], v: 3 } },
                                    b: {
                                        layout: {
                                            mode: "h",
                                            cells: {
                                                a: {
                                                    name: "c",
                                                    height: 1 / 4,
                                                    fsize: { h: [1, 2], v: [3, 4] }
                                                },
                                                b: {
                                                    layout: {
                                                        mode: "h",
                                                        cells: {
                                                            a: {
                                                                name: "d",
                                                                height: 1 / 3,
                                                                fsize: { h: [1, 2], v: [4, 5] }
                                                            },
                                                            b: {
                                                                layout: {
                                                                    mode: "h",
                                                                    cells: {
                                                                        a: {
                                                                            name: "e",
                                                                            fsize: { h: [1, 2], v: [5, 6] }
                                                                        },
                                                                        b: { name: "f", fsize: { h: [1, 2], v: 6 } }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        b: { name: "g", fsize: { h: 2 } }
                    }
                }
            }
        }
    },
    "7I": {
        mode: "h",
        cells: {
            a: { name: "a", height: 1 / 3, fsize: { v: 1 } },
            b: {
                layout: {
                    mode: "h",
                    cells: {
                        a: {
                            layout: {
                                mode: "v",
                                cells: {
                                    a: { name: "b", width: 1 / 5, fsize: { h: 3, v: [1, 2] } },
                                    b: {
                                        layout: {
                                            mode: "v",
                                            cells: {
                                                a: {
                                                    name: "c",
                                                    width: 1 / 4,
                                                    fsize: { h: [3, 4], v: [1, 2] }
                                                },
                                                b: {
                                                    layout: {
                                                        mode: "v",
                                                        cells: {
                                                            a: {
                                                                name: "d",
                                                                width: 1 / 3,
                                                                fsize: { h: [4, 5], v: [1, 2] }
                                                            },
                                                            b: {
                                                                layout: {
                                                                    mode: "v",
                                                                    cells: {
                                                                        a: {
                                                                            name: "e",
                                                                            fsize: { h: [5, 6], v: [1, 2] }
                                                                        },
                                                                        b: { name: "f", fsize: { h: 6, v: [1, 2] } }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        b: { name: "g", fsize: { v: 2 } }
                    }
                }
            }
        }
    }
};
dhtmlXLayoutObject.prototype._availAutoSize = {
    "1C": { h: ["a"], v: ["a"] },
    "2E": { h: ["a;b"], v: ["a", "b"] },
    "2U": { h: ["a", "b"], v: ["a;b"] },
    "3E": { h: ["a;b;c"], v: ["a", "b", "c"] },
    "3W": { h: ["a", "b", "c"], v: ["a;b;c"] },
    "3J": { h: ["a;c", "b"], v: ["a;b", "b;c"] },
    "3L": { h: ["a", "b;c"], v: ["a;b", "a;c"] },
    "3T": { h: ["a;b", "a;c"], v: ["a", "b;c"] },
    "3U": { h: ["a;c", "b;c"], v: ["a;b", "c"] },
    "4H": { h: ["a", "b;c", "d"], v: ["a;b;d", "a;c;d"] },
    "4I": { h: ["a;b;d", "a;c;d"], v: ["a", "b;c", "d"] },
    "4T": { h: ["a;b", "a;c", "a;d"], v: ["a", "b;c;d"] },
    "4U": { h: ["a;d", "b;d", "c;d"], v: ["a;b;c", "d"] },
    "4E": { h: ["a;b;c;d"], v: ["a", "b", "c", "d"] },
    "4W": { h: ["a", "b", "c", "d"], v: ["a;b;c;d"] },
    "4A": { h: ["a;b", "c", "d"], v: ["a;c;d", "b;c;d"] },
    "4L": { h: ["a", "b", "c;d"], v: ["a;b;c", "a;b;d"] },
    "4J": { h: ["a;b;c", "a;b;d"], v: ["a", "b", "c;d"] },
    "4F": { h: ["a;c;d", "b;c;d"], v: ["a;b", "c", "d"] },
    "4G": { h: ["a;b;c", "d"], v: ["a;d", "b;d", "c;d"] },
    "4C": { h: ["a", "b;c;d"], v: ["a;b", "a;c", "a;d"] },
    "5H": { h: ["a", "b;c;d", "e"], v: ["a;b;e", "a;c;e", "a;d;e"] },
    "5I": { h: ["a;b;e", "a;c;e", "a;d;e"], v: ["a", "b;c;d", "e"] },
    "5U": { h: ["a;e", "b;e", "c;e", "d;e"], v: ["a;b;c;d", "e"] },
    "5E": { h: ["a;b;c;d;e"], v: ["a", "b", "c", "d", "e"] },
    "5W": { h: ["a", "b", "c", "d", "e"], v: ["a;b;c;d;e"] },
    "5K": { h: ["a;b;c", "d;e"], v: ["a;d", "b;d", "c;d", "a;e", "b;e", "c;e"] },
    "5S": { h: ["a;b", "c;d;e"], v: ["a;c", "a;d", "a;e", "b;c", "b;d", "b;e"] },
    "5G": { h: ["a;b;c", "d", "e"], v: ["a;d;e", "b;d;e", "c;d;e"] },
    "5C": { h: ["a", "b", "c;d;e"], v: ["a;b;c", "a;b;d", "a;b;e"] },
    "6H": { h: ["a", "b;c;d;e", "f"], v: ["a;b;f", "a;c;f", "a;d;f", "a;e;f"] },
    "6I": { h: ["a;b;f", "a;c;f", "a;d;f", "a;e;f"], v: ["a", "b;c;d;e", "f"] },
    "6A": { h: ["a;b;c;d;e", "f"], v: ["a;f", "b;f", "c;f", "d;f", "e;f"] },
    "6C": { h: ["a", "b;c;d;e;f"], v: ["a;b", "a;c", "a;d", "a;e", "a;f"] },
    "6J": { h: ["a;b;c;d", "e", "f"], v: ["a;e;f", "b;e;f", "c;e;f", "d;e;f"] },
    "6E": { h: ["a", "b", "c;d;e;f"], v: ["a;b;c", "a;b;d", "a;b;e", "a;b;f"] },
    "6W": { h: ["a", "b", "c", "d", "e", "f"], v: ["a;b;c;d;e;f"] },
    "7H": {
        h: ["a", "b;c;d;e;f", "g"],
        v: ["a;b;g", "a;c;g", "a;d;g", "a;e;g", "a;f;g"]
    },
    "7I": {
        h: ["a;b;g", "a;c;g", "a;d;g", "a;e;g", "a;f;g"],
        v: ["a", "b;c;d;e;f", "g"]
    }
};
dhtmlXLayoutObject.prototype.setSeparatorSize = function (e, g) {
    if (typeof e == "number") {
        var h = this.setSeparatorSize({ index: e, current: -1 }, g);
        if (h.sep != null) {
            h.sep._setWH(g);
        }
        return;
    }
    for (var c in this.cdata) {
        if (this.cdata[c].dataType == "layout" &&
            this.cdata[c].dataNested == true &&
            this.cdata[c].dataObj != null) {
            e = this.cdata[c].dataObj.setSeparatorSize(e, g);
            if (e.sep != null) {
                return e;
            }
        }
        if (c == "a" && this.sep != null) {
            e.current++;
            if (e.index == e.current) {
                return { sep: this.sep };
            }
        }
    }
    return e;
};
export default dhtmlXLayoutObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXLayoutObject/dhtmlXLayoutObject.js